import { z } from 'zod';
import {
    BooleanFilter_Config_S,
    BooleanFilter_ControlsState_S,
    BooleanFilter_RequestParams_S,
    BooleanFilter_Snapshot_S,
    BooleanFilter_State_S,
    BooleanFilterAggregation_S,
} from './booleanFilter.schema';
import {
    KeyWordFilter_Config_S,
    KeyWordFilter_ControlsState_S,
    KeyWordFilter_RequestParams_S,
    KeyWordFilter_Snapshot_S,
    KeyWordFilter_State_S,
    KeyWordFilterAggregation_S,
} from './keywordFilter.schema';
import {
    NumberFilter_Config_S,
    NumberFilter_ControlsState_S,
    NumberFilter_RequestParams_S,
    NumberFilter_Snapshot_S,
    NumberFilter_State_S,
    NumberFilterAggregation_S,
} from './numberFilter.schema';

/**
 * FILTERS CONFIGURATION
 */
export const Filter_Config_S = z.union([KeyWordFilter_Config_S, NumberFilter_Config_S, BooleanFilter_Config_S]);

export const Filters_Config_S = z.array(Filter_Config_S);

/**
 * FILTERS STATE
 */
export const Filter_State_S = z.union([KeyWordFilter_State_S, NumberFilter_State_S, BooleanFilter_State_S]);

export const Filters_State_S = z.array(Filter_State_S);

/**
 * FILTERS CONTROLS STATE
 */
export const Filter_ControlsState_S = z.union([
    KeyWordFilter_ControlsState_S,
    NumberFilter_ControlsState_S,
    BooleanFilter_ControlsState_S,
]);

export const Filters_ControlsState_S = z.array(Filter_ControlsState_S);

/**
 * FILTERS REQUEST PARAMS
 */
export const Filter_RequestParams_S = z.union([
    KeyWordFilter_RequestParams_S,
    NumberFilter_RequestParams_S,
    BooleanFilter_RequestParams_S,
]);

export const Filters_RequestParams_S = z.array(Filter_RequestParams_S);

/**
 * FILTERS SNAPSHOT
 */
export const Filter_Snapshot_S = z.union([KeyWordFilter_Snapshot_S, NumberFilter_Snapshot_S, BooleanFilter_Snapshot_S]);

export const Filters_Snapshot_S = z.array(Filter_Snapshot_S);

/**
 * FILTER STATE AGGREGATION RESPONSE
 */
export const FilterAggregation_S = z.union([
    KeyWordFilterAggregation_S,
    NumberFilterAggregation_S,
    BooleanFilterAggregation_S,
]);

export const FilterAggregations_S = z.record(FilterAggregation_S);
